import { render, staticRenderFns } from "./CoachAccepted.vue?vue&type=template&id=6edaa7bf&"
import script from "./CoachAccepted.vue?vue&type=script&lang=js&"
export * from "./CoachAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports